import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `app1/contracts/${path}`;

// Staff
export function listContractTemplates() {
  return defaultClient.request({ url: URL('templates/') });
}

export function fetchContractTemplate(id) {
  return defaultClient.request({ url: URL(`templates/${id}/`) });
}

export function generateContract(payload = {}) {
  return defaultClient.request({ url: URL('generate/'), method: 'POST', payload });
}

export function sendContract(id, payload = {}) {
  return defaultClient.request({ url: URL(`${id}/send/`), method: 'POST', payload });
}

export function listContracts(clientSlug) {
  return defaultClient.request({ url: URL(`?client_slug=${clientSlug}`) });
}

// Public (no auth) — signing flow
export function fetchContractForSigning(signToken) {
  return defaultClient.request({ url: URL(`sign/${signToken}/`), auth: false });
}

export function signContract(signToken, payload = {}) {
  return defaultClient.request({ url: URL(`sign/${signToken}/`), method: 'POST', payload, auth: false });
}
